import React from "react";
import "../styles/how-it-works.css";

import ticket from "../assets/icons/ticket.svg";
import plane from "../assets/icons/plane.svg";
import coins from "../assets/icons/coins.svg";
import wallet from "../assets/icons/wallet.svg";
import arrow from "../assets/icons/arrow-dashed.svg";

const steps = [
  {
    number: "1",
    icon: ticket,
    title: "Book",
    text: "Book flights or hotels easily on Sky Terminal.",
  },
  {
    number: "2",
    icon: plane,
    title: "Travel",
    text: "Travel to your destination. Your journey is verified by our system.",
  },
  {
    number: "3",
    icon: coins,
    title: "Earn",
    text: "Earn MANGO rewards based on distance, activities, and missions.",
  },
  {
    number: "4",
    icon: wallet,
    title: "Use",
    text: "Use your rewards for discounts, staking, NFT upgrades, and more.",
  },
];

const HowItWorks = () => {
  return (
    <section className="how-section" id="how-it-works">
      <div className="container">
        <div className="how-wrapper">

          <h2 className="section-title">
            02 HOW IT WORKS
          </h2>

          {/* Desktop */}
          <div className="desktop-how d-none d-lg-block">

            <div className="steps-bar">

              {steps.map((step, index) => (
                <React.Fragment key={index}>

                  <div className="step-icon-wrap">
                    <span className="step-number">
                      {step.number}
                    </span>

                    <img
                      src={step.icon}
                      alt={step.title}
                      className="step-icon"
                    />
                  </div>

                  {index !== steps.length - 1 && (
                    <img
                      src={arrow}
                      alt=""
                      className="step-arrow"
                    />
                  )}

                </React.Fragment>
              ))}

            </div>

            <div className="step-content-row">

              {steps.map((step, index) => (
                <div
                  className="step-content"
                  key={index}
                >
                  <h4>{step.title}</h4>

                  <p>{step.text}</p>
                </div>
              ))}

            </div>

          </div>

          {/* Mobile */}
          <div className="mobile-how d-lg-none">

            <div className="mobile-left">

              {steps.map((step, index) => (
                <div
                  key={index}
                  className="mobile-step-icon"
                >
                  <span>{step.number}</span>

                  <img
                    src={step.icon}
                    alt=""
                  />

                  {index !== steps.length - 1 && (
                    <div className="mobile-arrow">
                      <i className="fa-solid fa-arrow-down"></i>
                    </div>
                  )}
                </div>
              ))}

            </div>

            <div className="mobile-right pt-4">

              {steps.map((step, index) => (
                <div
                  key={index}
                  className="mobile-step-content"
                >
                  <h4>{step.title}</h4>

                  <p>{step.text}</p>
                </div>
              ))}

            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default HowItWorks;